export default __webpack_public_path__ + "c956af010cd29c942e59828730241751.png";